(function () {
  function init(root) {
    root.querySelectorAll('[data-jgg-gallery]').forEach(function (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-jgg-slide]'));
      var dots = gallery.querySelector('[data-jgg-dots]');
      var active = 0;
      if (!slides.length) return;

      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === active); });
        dots.querySelectorAll('button').forEach(function (dot, i) { dot.classList.toggle('is-active', i === active); });
      }

      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Show product image ' + (index + 1));
        dot.addEventListener('click', function () { show(index); });
        dots.appendChild(dot);
      });
      gallery.querySelector('[data-jgg-prev]').addEventListener('click', function () { show(active - 1); });
      gallery.querySelector('[data-jgg-next]').addEventListener('click', function () { show(active + 1); });
      show(0);
    });

    var videoGallery = root.querySelector('[data-jgg-video-gallery]');
    if (videoGallery) {
      var panels = Array.prototype.slice.call(videoGallery.querySelectorAll('[data-jgg-video-panel]'));
      var tabs = Array.prototype.slice.call(videoGallery.querySelectorAll('[data-jgg-video-tab]'));
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          panels.forEach(function (panel, i) {
            panel.classList.toggle('is-active', i === index);
            if (i !== index) panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
          });
          tabs.forEach(function (item, i) { item.classList.toggle('is-active', i === index); });
        });
      });
    }
  }

  document.querySelectorAll('[data-jmmd-gift-guide]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-jmmd-gift-guide]');
    if (root) init(root);
  });
})();
